import PreviewIcon from "@mui/icons-material/Preview";
import {
  Box,
  Button,
  Card,
  Grid,
  Link,
  Modal,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useLoaderData } from "react-router-dom";
import ForbiddenAlert from "../../components/ForbiddenAlert";
import { formatStartFrom } from "../../utils/settingsTabHelper";
import { modalStyle } from "../../utils/urlsTabsHelper";
import CreativesTable from "./components/CreativesTable";

const CreativeTab = () => {
  const campaign = useLoaderData();
  const {
    artwork_url,
    podcast_name,
    episode_title,
    episode_link,
    cta_link,
    distributor_id,
    minimum_visit_length,
    campaign_state,
    cta_player,
  } = campaign;
  const startFromDisplay =
    "start_from" in campaign ? formatStartFrom(campaign.start_from) : "Not set";
  const pendingCampaignsSearchOptions = { status: "pending" };
  const liveCampaignsSearchOptions = { status: "live" };
  const [artWorkModalOpen, setArtWorkModalOpen] = useState(false);
  const [refreshPendingKey, setRefreshPendingKey] = useState(0);
  const [refreshOthersKey, setRefreshOthersKey] = useState(0);
  const [enableEmailButton, setEnableEmailButton] = useState(false);
  const [showForbiddenAlert, setShowForbiddenAlert] = useState(false);

  const refreshPendingUrls = () => {
    setRefreshPendingKey((prevKey) => prevKey + 1);
    setRefreshOthersKey((prevKey) => prevKey + 1);
  };
  const handleCloseArtWorkModal = () => {
    setArtWorkModalOpen(false);
  };
  return (
    <Grid
      container
      direction="column"
      alignItems="stretch"
      sx={{ height: "100%" }}
    >
      <Grid item sx={{ pb: 3 }}>
        <Typography variant="h6">Testing Suite</Typography>
        <Card>
          <Grid container sx={{ p: 2 }}>
            <Grid item xs={12}>
              <Typography variant="subtitle2">Distributor ID</Typography>
              {distributor_id}
            </Grid>
          </Grid>
        </Card>
      </Grid>
      <Grid item>
        <Typography variant="h6">Creatives</Typography>
        <Card>
          <Grid container sx={{ p: 2 }}>
            <Grid item xs={3}>
              <Typography variant="subtitle2">Podcast Show</Typography>
              {podcast_name}
            </Grid>
            <Grid item sx={{ pr: 1 }} xs={3}>
              <Typography variant="subtitle2">Artwork</Typography>
              {artwork_url && (
                <Grid item sx={{ display: "flex", alignItems: "flex-end" }}>
                  <PreviewIcon color="primary" fontSize="small" />
                  <Link
                    rel="noopener"
                    href="#"
                    onClick={(e) => setArtWorkModalOpen(true)}
                  >
                    Preview
                  </Link>
                </Grid>
              )}
            </Grid>
            <Grid item xs={3}>
              <Typography variant="subtitle2">
                Episode Minimum Play Time
              </Typography>
              {minimum_visit_length}
            </Grid>
            <Grid item xs={3}>
              <Typography variant="subtitle2">Episode Start From</Typography>
              {startFromDisplay}
            </Grid>
          </Grid>
          <Grid container sx={{ p: 2 }}>
            <Grid item xs={4}>
              <Typography variant="subtitle2">Episode</Typography>
              <a href={episode_link} rel="noreferrer" target="_blank">
                {episode_title}
              </a>
            </Grid>
            <Grid item xs={4}>
              <Typography variant="subtitle2">CTA Type</Typography>
              {cta_player}
            </Grid>
            <Grid item xs={4}>
              <Typography variant="subtitle2">CTA URL</Typography>
              <a
                href={cta_link}
                rel="noreferrer"
                target="_blank"
                style={{ wordBreak: "normal", overflowWrap: "anywhere" }}
              >
                {cta_link}
              </a>
            </Grid>
          </Grid>
        </Card>
      </Grid>
      <Grid item sx={{ pt: 5 }}>
        <CreativesTable
          searchOptions={pendingCampaignsSearchOptions}
          refreshMethod={refreshPendingUrls}
          refreshFlag={refreshPendingKey}
          enableEmailButtonMethod={setEnableEmailButton}
          onForbiddenError={() => setShowForbiddenAlert(true)}
          campaignStatus={campaign_state}
        />
      </Grid>
      <Grid item>
        <CreativesTable
          searchOptions={liveCampaignsSearchOptions}
          refreshMethod={refreshPendingUrls}
          refreshFlag={refreshOthersKey}
          enableEmailButtonVar={enableEmailButton}
          key={refreshOthersKey}
          onForbiddenError={() => setShowForbiddenAlert(true)}
          campaignStatus={campaign_state}
        />
      </Grid>
      <ForbiddenAlert
        open={showForbiddenAlert}
        onClose={() => setShowForbiddenAlert(false)}
      />
      <Modal
        open={artWorkModalOpen}
        onClose={handleCloseArtWorkModal}
        closeAfterTransition
      >
        <Box sx={modalStyle} alignItems="center">
          <Grid container>
            <Grid
              container
              item
              xs={12}
              justifyContent="center"
              alignItems="center"
            >
              <img
                alt="Podcast Artwork preview"
                src={artwork_url}
                style={{
                  maxHeight: "70vh",
                  maxWidth: "100%",
                  objectFit: "contain",
                }}
              />
            </Grid>
            <Grid container item xs={12} justifyContent="flex-end">
              <Button variant="text" onClick={handleCloseArtWorkModal}>
                CLOSE
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </Grid>
  );
};

export default CreativeTab;
